import { render } from "./CloudBackground.vue?vue&type=template&id=06cbccfd&scoped=true"
import script from "./CloudBackground.vue?vue&type=script&lang=js"
export * from "./CloudBackground.vue?vue&type=script&lang=js"

import "./CloudBackground.vue?vue&type=style&index=0&id=06cbccfd&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-06cbccfd"

export default script